import React from 'react'
import { GatsbyImage, withArtDirection } from 'gatsby-plugin-image'

const ResponsiveImage = ({ image, mobile, alt, ...props }) => {
  if (!mobile) return <GatsbyImage image={image} alt={alt} {...props} />
  const images = withArtDirection(image, [
    {
      media: '(max-width: 780px)',
      image: mobile
    }
  ])
  return <GatsbyImage image={images} alt={alt} {...props} />
}

export default ResponsiveImage
